// CustomerCompanyDetailsShimmer.tsx
import { Box, Skeleton, Stack } from '@mui/material';

export const CustomerCompanyDetailsShimmer = () => {
  return (
    <Box p={2}>
      {/* Card Sections */}
      {[1, 2, 3].map((i) => (
        <Box key={i} mb={2} p={2} borderRadius={3} bgcolor="#fff">
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="30%" />
        </Box>
      ))}
    </Box>
  );
};
